module.exports = __webpack_public_path__ + "static/media/ITBO04.4e92d235.jpg";